import Constants from '../constants.js'

let Settings = {}
const defaults = {
  radiusOptions: Constants.radiusOptions,
  startRangeOptions: Constants.startRangeOptions,
  endRangeOptions: Constants.endRangeOptions,
  SizeTypes: Constants.SizeTypes
}

Settings.install = function (Vue) {
  Vue.prototype.$settings = (key) => {
    return Object.assign(global.vesteda, defaults)[key]
  }
}

export default Settings
